export default {
  "hierarchy": {
    "dataTable": [
      "table-dataTable"
    ],
    "history": [
      "table-dataTable",
      "table-history"
    ],
    "pairingTable": [
      "table-dataTable",
      "table-pairingTable"
    ]
  },
  "props": {
    "default": {
      "filterButtonIconOff": "fa fa-filter",
      "filterButtonIconOn": "fa fa-filter",
      "filterButtonVariant": "linkSmall|link",
      "filterCancelButtonText": "Cancel",
      "filterCancelButtonVariant": "linkDestructive",
      "filterCheckboxVariant": "small",
      "filterClearButtonVariant": "linkDestructive",
      "filterOkayButtonText": "Apply",
      "filterPaneVariant": "tableFilter",
      "filterable": false,
      "paginate": false,
      "paginationDropdownVariant": "small",
      "paginationNextButtonIcon": "fa fa-chevron-right",
      "paginationPreviousButtonIcon": "fa fa-chevron-left",
      "sortable": false
    },
    "dataTable": {
      "filterButtonIconOff": "fa fa-filter",
      "filterButtonIconOn": "fa fa-filter",
      "filterButtonVariant": "linkSmall|link",
      "filterCancelButtonText": "Cancel",
      "filterCancelButtonVariant": "linkDestructive",
      "filterCheckboxVariant": "small",
      "filterClearButtonVariant": "linkDestructive",
      "filterOkayButtonText": "Apply",
      "filterPaneVariant": "tableFilter",
      "filterable": true,
      "paginate": true,
      "paginationDropdownVariant": "small",
      "paginationNextButtonIcon": "fa fa-chevron-right",
      "paginationPreviousButtonIcon": "fa fa-chevron-left",
      "sortable": true
    },
    "history": {
      "filterButtonIconOff": "fa fa-filter",
      "filterButtonIconOn": "fa fa-filter",
      "filterButtonVariant": "linkSmall|link",
      "filterCancelButtonText": "Cancel",
      "filterCancelButtonVariant": "linkDestructive",
      "filterCheckboxVariant": "small",
      "filterClearButtonVariant": "linkDestructive",
      "filterOkayButtonText": "Apply",
      "filterPaneVariant": "tableFilter",
      "filterable": true,
      "paginate": true,
      "paginationDropdownVariant": "small",
      "paginationNextButtonIcon": "fa fa-chevron-right",
      "paginationPreviousButtonIcon": "fa fa-chevron-left",
      "sortable": true
    },
    "pairingTable": {
      "filterButtonIconOff": "fa fa-filter",
      "filterButtonIconOn": "fa fa-filter",
      "filterButtonVariant": "linkSmall|link",
      "filterCancelButtonText": "Cancel",
      "filterCancelButtonVariant": "linkDestructive",
      "filterCheckboxVariant": "small",
      "filterClearButtonVariant": "linkDestructive",
      "filterOkayButtonText": "Apply",
      "filterPaneVariant": "tableFilter",
      "filterable": false,
      "paginate": false,
      "paginationDropdownVariant": "small",
      "paginationNextButtonIcon": "fa fa-chevron-right",
      "paginationPreviousButtonIcon": "fa fa-chevron-left",
      "sortable": false
    }
  }
}